import { Link, useParams } from 'react-router'
import Table from '../Components/AdminTable.js'
import { useEffect, useState } from 'react'
import { call } from '../Methods.js'
import { use } from '../Helpers.js'
import FormModal from '../Components/FormModal.js'

function Groups () {
  const pageName = 'groups'
  const pageTitle = 'Qruplar'
  document.title = `${pageTitle} | ${process.env.REACT_APP_NAME}`
  const [updateTable, setUpdateTable] = useState(false)

  useEffect(() => {
    if (updateTable) {
      setUpdateTable(false)
    }
  }, [updateTable])

  const tableSettings = {
    name: '',
    label: '',
    filters: true,
    pagination: true,
    actions: {
      get: async (params = {}) => {
        const groups = await call.forLoggedUser.group.getGroups(params)
        if (groups.success) {
          return groups.data
        }
        return []
      }
    },
    columns: [
      {
        title: '#',
        property: 'rowNumber',
        style: { width: '30px' },
        filter: {
          enabled: false
        }
      },
      {
        title: 'Filial',
        property: ['branchCode','branchName'],
        mutate:(values)=><span title={values[1]}>{values[0]}</span>,
        filter: {
          enabled: true,
          type: 'select',
          name: 'branchId',
          dataSource: async () => {
            const source = await call.forLoggedUser.branch.getBranches({})
            let data = source.data.map(d => {
              return { value: d.id, text: d.name }
            })
            return data
          }
        },
        style: { width: '10%' },
      },
      {
        title: 'Qrupun adı',
        property: 'name',
        style: { width: '25%' },
        filter: {
          enabled: true,
          type: 'text',
          name: 'name'
        },
        sort: {
          enabled: true
        }
      },
      {
        title: 'Təlim',
        property: 'courseName',
        style: { width: '25%' },
        filter: {
          enabled: true,
          type: 'select',
          name: 'courseId',
          dataSource: async () => {
            const source = await call.forLoggedUser.course.getCourses({})
            let data = source.data.map(d => {
              return { value: d.id, text: d.name }
            })
            return data
          }
        }
      },
      {
        title: 'Başlama tarixi',
        property: 'startDate',
        style: { width: '10%' },
        filter: {
          enabled: true,
          type: 'month',
          name: 'startMonth'
        },
        mutate: value => {
          return use.convertDatetimeToShortDate(value)
        }
      },
      {
        title: 'İştirakçılar',
        property: 'activeStudents',
        style: { width: '10%' },
        filter: {
          enabled: false,
          type: 'number'
        },
        mutate: value => {
          return (
            <span className='link' to={'/'}>
              {value} nəfər
            </span>
          )
        }
      },
      {
        title: 'Status',
        property: ['statusId','statusName'],
        type:'status-label',
        filter: {
          enabled: true,
          type: 'select',
          name: 'statusId',
          dataSource: async () => {
            const source = await call.forLoggedUser.status.getStatuses({
              type: 'group'
            })
            let data = source.data.map(d => {
              return { value: d.id, text: d.description }
            })
            return data
          }
        },
        style: { width: '10%' },
        mutate:(values)=>{
          return values[1]
        }
      },
      {
        title: 'Əməliyyat',
        property: 'id',
        type: 'actions-list',
        operations:(value)=>[
          {
            type:'link',
            name:'Edit',
            title:'Düzəliş',
            link:`${value}`,
            iconType:'path',
            icon:'/Images/Icons/edit.png',
            disablingConditions:[],
          },
          {
            type:'command',
            name:'delete',
            title:'Qeydi sil',
            warning:`Qrupa aid bütün məlumatlar, o cümlədən, \n - İştirakçı \n - Dərs \n - Ödəniş \n məlumatları birdəfəlik silinəcək.`,
            parameters:`{"id":${value},"entity":"group"}`,
            iconType:'path',
            icon:'/Images/Icons/delete.png',
            disablingConditions:[]
          }
        ],
        style: {width:'10%',minWidth: '50px'}
      }
    ],
    addNew: {
      enabled: true,
      url: `/${pageName}/add`,
      title: '+ Əlavə et'
    }
  }

  const formSettings = [
    {
      name: 'group',
      id: '',
      label: 'Qrup',
      isStandAlone: true,
      isMain: true,
      actions: {
        get: id => call.forLoggedUser.group.getGroupById({ id: id }),
        add: call.forLoggedUser.group.addGroup,
        edit: call.forLoggedUser.group.updateGroup
      },
      formLists: {
        Branches: async () => {
          const source = await call.forLoggedUser.branch.getBranches({})
          let data = source.data.map(d => {
            return { value: d.id, text: d.name }
          })
          return data
        },
        Courses: async () => {
          const source = await call.forLoggedUser.course.getCourses({})
          let data = source.data.map(d => {
            return { value: d.id, text: d.name }
          })
          return data
        },
        GroupTypes: async () => {
          const source = await call.forLoggedUser.listOption.getListOptions({
            listName: 'GroupType'
          })
          let data = source.data.map(d => {
            return { value: d.value, text: d.text }
          })
          return data
        },
        Statuses: async () => {
          const source = await call.forLoggedUser.status.getStatuses({
            type: 'group'
          })
          let data = source.data.map(d => {
            return { value: d.id, text: d.description }
          })
          return data
        }
      },
      fields: [
        { type: 'hidden', fieldName: 'id', label: '' },
        {
          label: 'Qrupun adı',
          fieldName: 'name',
          validationRules: ['required'],
          col: { sm: 3 }
        },
        {
          label: 'Filial',
          fieldName: 'branchId',
          type: 'select',
          validationRules: ['required'],
          col: { sm: 3 },
          data: 'Branches'
        },
        {
          label: 'Təlim / Kurs',
          type: 'select',
          fieldName: 'courseId',
          validationRules: ['required'],
          col: { sm: 3 },
          data: 'Courses'
        },
        {
          label: 'Müddət (ay)',
          type: 'number',
          fieldName: 'months',
          col: { sm: 3 }
        },
        {
          label: 'Başlama tarixi',
          type: 'date',
          fieldName: 'startDate',
          col: { sm: 3 },
          mutate: value => {
            return new Date(value).toLocaleDateString('az-AZ')
          }
        },
        {
          label: 'Bitmə tarixi',
          type: 'date',
          fieldName: 'endDate',
          col: { sm: 3 },
          mutate: value => {
            return new Date(value).toLocaleDateString('az-AZ')
          }
        },
        {
          label: 'Tədris növü',
          type: 'select',
          fieldName: 'type',
          col: { sm: 3 },
          data: 'GroupTypes'
        },
        {
          label: 'Dərs günləri',
          type: 'input-group-row',
          fieldName: 'schedule',
          defaultValue: [],
          multipleRows: true,
          addRowPermission: true,
          removeRowPermission: true,
          rowStyleRules: [
            {
              fieldName: 'id',
              getStyleRule: value =>
                value < 0 ? { backgroundColor: '#ffd4d4' } : {}
            }
          ],
          col: { sm: 12 },
          rowFields: [
            {
              type: 'hidden',
              fieldName: 'id',
              col: { sm: 0 }
            },
            {
              label: 'Gün',
              type: 'select',
              validationRules:['required'],
              fieldName: 'weekDay',
              data: [
                { value: 1, text: 'Bazar ertəsi' },
                { value: 2, text: 'Çərşənbə axşamı' },
                { value: 3, text: 'Çərşənbə' },
                { value: 4, text: 'Cümə axşamı' },
                { value: 5, text: 'Cümə' },
                { value: 6, text: 'Şənbə' },
                { value: 7, text: 'Bazar' }
              ],
              columnWidth: '30%',
            },
            {
              label: 'Başlayır',
              type: 'time',
              fieldName: 'begins',
              columnWidth: '25%',
            },
            {
              label: 'Bitir',
              type: 'time',
              fieldName: 'ends',
              columnWidth: '25%',
            },
            {
              label: 'Əməliyyatlar',
              type: 'operations',
              fieldName: 'id',
              columnWidth: '20%',
              operations: [
                {
                  type: 'delete',
                  title: 'Sil',
                  iconType:'path',
                  icon:'/Images/Icons/delete.png',
                  iconStyle:{filter:'invert(1)'},
                  disablingConditions: [
                    
                  ]
                }
              ]
            }

          ]
        },
        {
          label: 'Əlavə qeydlər',
          type: 'textarea',
          fieldName: 'notes',
          col: { sm: 12 }
        },
        {
          label: 'Status',
          type: 'select',
          fieldName: 'statusId',
          col: { sm: 6 },
          data: 'Statuses'
        },
        { type: 'submit', label: 'Təsdiq', col: { sm: 12 } }
      ]
    },
    {
      name: 'students',
      id: '',
      label: 'İştirakçılar',
      isStandAlone: false,
      isMain: false,
      actions: {
        get: id => call.forLoggedUser.group.getStudentList({ groupId: id }),
        edit: call.forLoggedUser.group.editStudentList
      },
      formLists: {
        Candidates: async (id) => {
          const source = await call.forLoggedUser.candidate.getCandidates({})
          let data = source.data?.map(d => {
            return {
              value: d.id,
              text: `${d.name} ${d.surname} - ${d.requesterFullName}`
            }
          })
          return data
        },
        Students: async (id) => {
          const source = await call.forLoggedUser.group.getStudentList({groupId:id})
          let data = source.data?.students?.map(d => {
            return {
              value: d.studentId,
              text: `${d.studentFullName}`
            }
          })
          return data
        },
        Statuses: async () => {
          const source = await call.forLoggedUser.status.getStatuses({
            type: 'studentGroup'
          })
          let data = source.data.map(d => {
            return { value: d.id, text: d.description }
          })
          return data
        }
      },
      fields: [
        { type: 'hidden', fieldName: 'groupId'},
        {
          label: 'Qrupun adı',
          type: 'readonly-text',
          fieldName: 'groupName',
          col: { sm: 4 }
        },
        {
          label: 'Təlim / Kurs',
          type: 'readonly-text',
          fieldName: 'courseName',
          col: { sm: 8 }
        },
        {
          label: 'İştirakçılar',
          type: 'input-group-row',
          fieldName: 'students',
          defaultValue: [],
          multipleRows: true,
          addRowPermission: true,
          removeRowPermission: false,
          rowStyleRules: [
            {
              fieldName: 'id',
              getStyleRule: value =>
                value < 0 ? { backgroundColor: '#ffd4d4' } : {}
            },
            {
              fieldName: 'statusId',
              getStyleRule: value => {
                switch (value) {
                  case 3:
                    return { backgroundColor: '#fffcd2ff' }
                  case -2:
                    return { backgroundColor: '#ffe9b0' }
                  default: {
                  }
                }
              }
            }
          ],
          col: { sm: 12 },
          rowFields: [
            {
              type: 'hidden',
              fieldName: 'id',
              columnWidth: 0
            },
            {
              label: 'İştirakçı',
              type: 'select',
              fieldName: 'studentId',
              validationRules: ['required'],
              columnWidth: '20%',
              parameters:['line:id'],
              data:(params)=> params.id? 'Students':'Candidates',
              disablingConditions:[
                {
                  fieldName:'id',
                  checkCondition:(value)=>![null,undefined,''].includes(value)
                }
              ]
            },
            {
              label: 'Əlaqə',
              type: 'text',
              fieldName: 'phone',
              disabled: true,
              columnWidth: '15%'
            },
            {
              label: 'Aylıq',
              type: 'number',
              fieldName: 'monthlyPayment',
              defaultValue: '0',
              columnWidth: '5%'
            },
            {
              label: 'Ümumi',
              type: 'number',
              fieldName: 'totalPrice',
              defaultValue: '0',
              disabled: true,
              columnWidth: '5%'
            },
            {
              label: 'Ödənmiş',
              type: 'number',
              fieldName: 'totalPaid',
              defaultValue: '0',
              disabled: true,
              columnWidth: '5%'
            },
            {
              label: 'Qalıq',
              type: 'number',
              fieldName: 'remaining',
              defaultValue: '0',
              disabled: true,
              columnWidth: '5%'
            },
            {
              label: 'Qeydlər',
              type: 'text',
              fieldName: 'notes',
              columnWidth: '20%'
            },
            {
              label: 'Status',
              type: 'select',
              fieldName: 'statusId',
              columnWidth: '20%',
              data: 'Statuses',
              col: { sm: 2 }
            },
            {
              label: 'Əməliyyatlar',
              type: 'operations',
              fieldName: 'id',
              operations: [
                {
                  type:'command',
                  name: 'groupTransfer',
                  title:'Qrupu dəyiş',
                  iconType:'path',
                  icon:'/Images/Icons/transfer.png',
                  parameters: ['line:id','line:studentFullName','global:groupId'],
                  disablingConditions: [
                    {
                      fieldName: 'statusId',
                      checkCondition: value=>![0,1].includes(value)
                    }
                  ]
                },
                {
                  type: 'delete',
                  title: 'Sil',
                  iconType:'path',
                  icon:'/Images/Icons/delete.png',
                  iconStyle:{filter:'invert(1)'},
                  disablingConditions: [
                    {
                      fieldName: 'totalPaid',
                      description:'Balansı müsbət olan iştirakçı silinə bilməz. Əvvəlcə iştirakçının balansını sıfırlayın.',
                      checkCondition: value => value > 0
                    }
                  ]
                }
              ]
            }
          ]
        },
        { type: 'submit', label: 'Yadda saxla', col: { sm: 12 } }
      ]
    },
    {
      name: 'payments',
      id: '',
      label: 'Ödənişlər',
      isStandAlone: false,
      isMain: false,
      actions: {
        get: id => call.forLoggedUser.group.getPaymentList({ groupId: id }),
        edit: call.forLoggedUser.group.editPaymentList
      },
      formLists: {
        Students: async id => {
          const source = await call.forLoggedUser.group.getStudentList({
            groupId: id
          })
          
          let data = source.data?.students?.map(d => {
            return {
              value: d.id,//studentGroupId
              text: `${d.studentFullName}`
            }
          })
          return data
        },
        PaymentTypes: async () => {
          const source = await call.forLoggedUser.listOption.getListOptions({
            listName: 'PaymentType'
          })
          let data = source.data?.map(d => {
            return { value: d.value, text: d.text }
          })
          return data
        },
        Statuses: async () => {
          const source = await call.forLoggedUser.status.getStatuses({
            type: 'payment'
          })
          let data = source.data.map(d => {
            return { value: d.id, text: d.description }
          })
          return data
        }
      },
      fields: [
        { type: 'hidden', fieldName: 'groupId', label: '' },
        {
          label: 'Qrupun adı',
          type: 'readonly-text',
          fieldName: 'groupName',
          col: { sm: 4 }
        },
        {
          label: 'Təlim / Kurs',
          type: 'readonly-text',
          fieldName: 'courseName',
          col: { sm: 4 }
        },
        {
          label: 'Ödənişlər',
          type: 'input-group-row',
          fieldName: 'payments',
          defaultValue: [],
          addRowPermission: true,
          multipleRows: true,
          removeRowPermission: true,
          rowStyleRules: [
            {
              fieldName: 'statusId',
              getStyleRule: value =>
                value == -2 ? { backgroundColor: '#ffe9b0' } : {}
            },
            {
              fieldName: 'id',
              getStyleRule: value =>
                value < 0 ? { backgroundColor: '#ffd4d4' } : {}
            }
          ],
          col: { sm: 12 },
          rowFields: [
            {
              label: '',
              type: 'hidden',
              fieldName: 'id'
            },
            {
              label: 'İştirakçı',
              type: 'select',
              fieldName: 'studentGroupId',
              validationRules: ['required'],
              columnWidth: '17%',
              data: 'Students'
            },
            {
              label: 'Tarix',
              type: 'date',
              fieldName: 'paidDate',
              validationRules: ['required'],
              columnWidth: '15%',
              defaultValue: new Date().toLocaleDateString('az-AZ'),
              mutate: value => {
                return value!=null?new Date(value).toLocaleDateString('az-AZ'):null
              }
            },
            {
              label: 'Tip',
              type: 'select',
              fieldName: 'paymentTypeId',
              columnWidth: '10%',
              data: 'PaymentTypes'
            },
            {
              label: 'Məbləğ',
              type: 'number',
              fieldName: 'amount',
              defaultValue:'0',
              validationRules: ['positive'],
              columnWidth: '10%'
            },
            {
              label: 'Açıqlama',
              type: 'text',
              fieldName: 'description',
              columnWidth: '20%'
            },
            {
              label: 'Status',
              type: 'select',
              fieldName: 'statusId',
              defaultValue:1,
              columnWidth: '18%',
              data: 'Statuses'
            },
            {
              label: 'Əməliyyatlar',
              type: 'operations',
              fieldName: 'id',
              columnWidth: '10%',
              operations: [
                {
                  type: 'delete',
                  title: 'Sil',
                  iconType:'path',
                  icon:'/Images/Icons/delete.png',
                  iconStyle:{filter:'invert(1)'},
                  disablingConditions: [
                  ]
                }
              ]
            }
          ]
        },
        { type: 'submit', label: 'Yadda saxla', col: { sm: 12 } }
      ]
    },
    {
      name: 'classes',
      id: '',
      label: 'Dərslər',
      isStandAlone: false,
      isMain: false,
      actions: {
        get: id => call.forLoggedUser.group.getClassList({ groupId: id }),
        edit: call.forLoggedUser.group.editClassList
      },
      formLists: {
        ClassTypes: async () => {
          const source = await call.forLoggedUser.listOption.getListOptions({
            listName: 'ClassType'
          })
          let data = source.data.map(d => {
            return { value: d.value, text: d.text }
          })
          return data
        },
        Statuses: async () => {
          const source = await call.forLoggedUser.status.getStatuses({
            type: 'class'
          })
          let data = source.data.map(d => {
            return { value: d.id, text: d.description }
          })
          return data
        }
      },
      fields: [
        { type: 'hidden', fieldName: 'groupId', label: '' },
        {
          label: 'Qrupun adı',
          type: 'readonly-text',
          fieldName: 'groupName',
          col: { sm: 4 }
        },
        {
          label: 'Təlim / Kurs',
          type: 'readonly-text',
          fieldName: 'courseName',
          col: { sm: 4 }
        },
        {
          label: 'Dərsləri qrafikə uyğun yarat',
          type: 'button',
          col: { sm: 4 },
          eventHandlers: [
            {
              type: 'click',
              handler: () => alert(1)
            }
          ]
        },
        {
          label: 'Dərslər',
          type: 'input-group-row',
          fieldName: 'classes',
          defaultValue: [],
          multipleRows: true,
          addRowPermission: true,
          removeRowPermission: false,
          defaultRowCountField: 'classesPerWeek',
          rowStyleRules: [
            {
              fieldName: 'statusId',
              getStyleRule: value => {
                switch (value) {
                  case -2:
                    return { backgroundColor: '#fffcd2ff' }
                  case -3:
                    return { backgroundColor: '#ffe9b0' }
                  default: {
                  }
                }
              }
            }
          ],
          col: { sm: 12 },
          rowFields: [
            {
              type: 'hidden',
              fieldName: 'id',
              col: { sm: 0 }
            },
            {
              label: 'Tarix',
              type: 'date',
              fieldName: 'date',
              validationRules: ['required'],
              columnWidth: '15%',
              mutate: value => new Date(value).toLocaleDateString('az-AZ')
            },
            {
              label: 'Növ',
              type: 'select',
              fieldName: 'typeId',
              validationRules: ['required'],
              columnWidth: '15%',
              data: 'ClassTypes'
            },
            {
              label: 'Başlama',
              type: 'time',
              fieldName: 'beginTime',
              validationRules: ['required'],
              columnWidth: '15%'
            },
            {
              label: 'Bitmə',
              type: 'time',
              fieldName: 'endTime',
              validationRules: ['required'],
              columnWidth: '15%'
            },
            {
              label: 'Say',
              type: 'text',
              fieldName: 'attendance',
              disabled: true,
              columnWidth: '5%'
            },
            {
              label: 'Qeydlər',
              type: 'text',
              fieldName: 'notes',
              columnWidth: '20%'
            },
            {
              label: 'Status',
              type: 'select',
              fieldName: 'statusId',
              defaultValue: 0,
              columnWidth: '15%',
              data: 'Statuses'
            }
          ]
        },
        { type: 'submit', label: 'Yadda saxla', col: { sm: 12 } }
      ]
    }
  ]

  return (
    <div className='page'>
      <h1 className='page-title'>{pageTitle}</h1>
      <Table tableSettings={tableSettings} updateTable={updateTable} />

      <FormModal
        moduleUrl={`/${pageName}`}
        formSettings={formSettings}
        onSubmit={() => setUpdateTable(true)}
      />
    </div>
  )
}

export default Groups
